import type { Clue } from "@shared/types.ts"

interface ClueItemProps {
  clue: Clue
  isActive: boolean
  onClick: () => void
}

function formatLetterCount(clue: { answer: string; length: number; displayAnswer?: string }): string {
  // Use displayAnswer (spaced form) if available, e.g. "ACTS OUT" → (4,3)
  const form = clue.displayAnswer ?? clue.answer
  if (form.includes(" ")) {
    return `(${form.split(" ").map((w) => w.length).join(",")})`
  }
  return `(${clue.length})`
}

export function ClueItem({ clue, isActive, onClick }: ClueItemProps) {
  return (
    <div
      className={`clue-item ${isActive ? "clue-item--active" : ""}`}
      onClick={onClick}
    >
      <span className="clue-number">{clue.number}</span>
      <span className="clue-text">
        {clue.clue} <span className="clue-length">{formatLetterCount(clue)}</span>
      </span>
    </div>
  )
}
